import { render, staticRenderFns } from "./ModalShowColor.vue?vue&type=template&id=28aa6f84&"
import script from "./ModalShowColor.vue?vue&type=script&lang=js&"
export * from "./ModalShowColor.vue?vue&type=script&lang=js&"
import style0 from "./ModalShowColor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports